import { schema as schemas } from 'normalizr'

import { CallApi } from '@signavio/kraken'

import { WorkflowSummaryT } from '../../../types'

import { LABELS } from '../organizations'
import { USER } from '../users'

export const collection = 'workflowPreview'

export const schema = new schemas.Entity(
  collection,
  {
    owner: USER.schema,
    editor: USER.schema,
    labels: LABELS.schema,
  },

  {
    processStrategy: (workflowSummary: WorkflowSummaryT) => ({
      ...workflowSummary,
      editor: workflowSummary.editor || null,
      editorId: workflowSummary.editorId || null,
    }),
  }
)

type FetchQueryType = {
  id: string
}
// Warning: This endpoint is identical to workflowSummary endpoint but for this endpoint the backend does
// not check the user's access rights before returning a WORKFLOW_SUMMARY you could expose data you don't intent to
export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: FetchQueryType) =>
    callApi(`${apiBase}/workflows/${id}/preview`, schema)
